import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { MatDialog } from '@angular/material/dialog';
import { EditOpeningHoursDialogComponent } from './edit-dialog/edit-opening-hours-dialog.component';

@Component({
  selector: 'opening-hours',
  templateUrl: './opening-hours.component.html',
  styleUrls: ['./opening-hours.component.scss'],
  standalone: false
})

export class OpeningHoursComponent implements OnInit {
  @Input() dynamicContent: Models.DynamicContent;
  @Input() translations: any;
  @Input() type: string;
  @Input() activeLanguage: string;
  displayRegularButton = true;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit() {
    this.dynamicContent.content.openingInfo = this.dynamicContent.content.openingInfo || this.generateOpeningInfo(this.dynamicContent.content.openingHours);
    this.displayRegularButton = !this.dynamicContent.content.openingInfo.find(el => !el.startDate && !el.endDate);
  }

  generateOpeningInfo(openingHours: Models.OpeningHours) {
    if (!this.dynamicContent.content?.openingHours?.regularOpeningHours && !this.dynamicContent.content?.openingHours?.exceptionDays?.length) {
      return Array.isArray(this.dynamicContent.content?.openingHours) ? this.dynamicContent.content?.openingHours : [];
    }
    const openingInfo = [];
    const regular = new Models.OpeningInfo();
    this.translations['de'] = this.dynamicContent;
    const titles = [];
    const regularTitles = { de: 'Reguläre Öffnungszeiten', en: 'Regular opening hours', fr: 'Heures d\'ouverture régulières', it: 'Orari di apertura regolari' };
    for (const key of Object.keys(this.translations)) {
      titles.push({ language: key, title: regularTitles[key] });
    }
    regular.titles = titles;
    const days = [];
    for (const key of Object.keys(openingHours.regularOpeningHours)) {
      const day = new Models.OpeningTimeDay();
      day.populateFromJSON({
        day: key, open: openingHours.regularOpeningHours[key].open, times: openingHours.regularOpeningHours[key].times
      });
      days.push(day);
    }
    regular.days = days;
    openingInfo.push(regular);
    for (const element of openingHours?.exceptionDays || []) {
      const exception = new Models.OpeningInfo();
      const exceptionTitles = Object.keys(this.translations).map(el => {
        return { language: el, title: element.title }
      });
      exception.populateFromJSON({ titles: exceptionTitles, open: element.open, times: element.times, startDate: element.date });
      openingInfo.push(exception);
    }
    return openingInfo;
  }

  getTitle(item) {
    return item.titles.find(el => el.language === this.activeLanguage)?.title || '[Titel noch nicht übersetzt]';
  }

  isActive(item) {
    const activeItems = [];
    let regular;
    for (const element of this.dynamicContent.content.openingInfo) {
      const today = new Date();
      const startDate = new Date(element.startDate);
      const endDate = new Date(element.endDate);
      if (
        !!element.startDate && !element.endDate && startDate.getDate() === today.getDate() && startDate.getMonth() === today.getMonth()
        && startDate.getFullYear() === today.getFullYear()
      ) {
        return item === element;
      } else if (!!element.startDate && !!element.endDate && this.isTodayBetween(startDate, endDate, today)) {
        activeItems.push(element);
      } else if (!element.startDate && !element.endDate) {
        regular = element;
      }
    }
    let currentDifference = 999999999999999999999;
    if (activeItems.length) {
      let finalElement;
      for (const element of activeItems) {
        const diff = new Date(element.endDate).getTime() - new Date(element.startDate).getTime();
        if (diff < currentDifference) {
          finalElement = element;
          currentDifference = diff;
        }
      }
      if (item === finalElement) {
        return true;
      }
    } else if (regular && regular === item) {
      return true;
    }
    return false;
  }

  isTodayBetween(startDate, endDate, today) {
    today.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return today >= startDate && today <= endDate;
  }

  async editOpeningInfo(type?, index?: number) {
    if (!type && this.dynamicContent.content.openingInfo[index]) {
      type = !this.dynamicContent.content.openingInfo[index].startDate && !this.dynamicContent.content.openingInfo[index].endDate ? 'regular' :
        (!!this.dynamicContent.content.openingInfo[index].endDate ? 'span' : 'day');
    }
    const data = { type, index: index, translations: this.translations, language: this.activeLanguage, data: JSON.parse(JSON.stringify(this.dynamicContent.content.openingInfo)) };
    const openingInfo: Models.OpeningInfo[] = await this.dialog.open(EditOpeningHoursDialogComponent, { width: '800px', data }).afterClosed().toPromise();
    if (!openingInfo) {
      return;
    }
    if (type === 'regular') {
      this.displayRegularButton = false;
    }
    if (this.dynamicContent.content.openingInfo[index]) {
      this.dynamicContent.content.openingInfo[index] = openingInfo;
    } else {
      this.dynamicContent.content.openingInfo.push(openingInfo);
    }
  }

  removeOpeningInfo(index: number) {
    if (!this.dynamicContent.content.openingInfo[index].startDate && !this.dynamicContent.content.openingInfo[index].endDate) {
      this.displayRegularButton = true;
    }
    this.dynamicContent.content.openingInfo.splice(index, 1);
  }
}
